var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPt007ColorDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "backend_color_diamond",
    transform: "translate(-500 -936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_987",
    "data-name": "Rectangle 987",
    transform: "translate(500 984) rotate(-45)",
    fill: "#f5ffd9",
    stroke: "#ace809",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.882,
    height: 67.882,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 59.882,
    height: 59.882,
    rx: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "memory_black_24dp",
    transform: "translate(528 964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    d: "M0,0H40V40H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M23,13H13V23H23Zm-3.333,6.667H16.333V16.333h3.333ZM33,16.333V13H29.667V9.667a3.343,3.343,0,0,0-3.333-3.333H23V3H19.667V6.333H16.333V3H13V6.333H9.667A3.343,3.343,0,0,0,6.333,9.667V13H3v3.333H6.333v3.333H3V23H6.333v3.333a3.343,3.343,0,0,0,3.333,3.333H13V33h3.333V29.667h3.333V33H23V29.667h3.333a3.343,3.343,0,0,0,3.333-3.333V23H33V19.667H29.667V16.333Zm-6.667,10H9.667V9.667H26.333Z",
    transform: "translate(2 2)",
    fill: "#ace809"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt007ColorDiamond);
export default __webpack_public_path__ + "static/media/PT007_color_diamond.3e3201c232149b7836be5451293ceefa.svg";
export { ForwardRef as ReactComponent };